import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
// @mui
import {
    Card,
    Stack,
    Typography,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    Divider,
    useMediaQuery,
    TextField,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomFilter from 'src/components/filter/CustomFilter';
import ClearButton from 'src/components/shared/ClearButton';
import FilterButton from 'src/components/shared/FilterButton';
import DynamicTable from 'src/components/shared/DynamicTable';
import ExportToExcelButton from 'src/components/shared/ExportToExcelButton';

export default function PersonalPackages() {
    const isMobile = useMediaQuery('(max-width:768px)');
    const [originalData, setOriginalData] = useState([]);
    const [packageList, setPackageList] = useState([]);
    const [showPopUpError, setShowPopUpError] = useState(false);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedCargoStatus, setSelectedCargoStatus] = useState('');
    const [filterBarcode, setFilterBarcode] = useState('');
    const [filterModal, setFilterModal] = useState(false);

    const TABLE_HEAD = [
        {
            id: 'barcode',
            label: 'Barkod No'
        },
        {
            id: 'takeDate',
            label: 'Zimmete Alma Tarihi',
            format: (_, row) =>
                moment
                    .unix()
                    .format('DD.MM.YYYY'),
        },
        {
            id: 'deliverDate',
            label: 'Teslim Tarihi',
            format: (_, row) =>
                moment
                    .unix()
                    .format('DD.MM.YYYY'),
        },
        {
            id: 'packageCount',
            label: 'Paket Adedi'
        },
        {
            id: 'shipmentFirm',
            label: 'Kargo Firması'
        },
        {
            id: 'cargoStatus',
            label: 'Kargo Durumu'
        },
        {
            id: 'operation',
            label: 'Destek Talebi'
        },
    ];

    return (
        <>
            <Helmet>
                <title>Kişisel Paketlerim | Mall Logistics Panel</title>
            </Helmet>

            <Stack spacing={4} sx={{ p: 3 }}>
                <Stack
                    direction={isMobile ? 'column' : 'row'}
                    alignItems="end"
                    justifyContent="space-between"
                    paddingY={2}
                    paddingX={1}
                    spacing={2}
                >
                    <Typography variant="h4">Kişisel Paketlerim</Typography>
                    <div style={{flexDirection:'row',display:'flex'}}>
                        <ExportToExcelButton
                            setShowPopUpError={setShowPopUpError}
                            showPopUpError={showPopUpError}
                            onClick={() => console.log("export to excel")}
                            sx={{ marginLeft: '7px' }}
                        />
                    </div>

                    {isMobile && (
                        <Button variant="outlined" onClick={() => setFilterModal(true)}>
                            Filtrele
                        </Button>
                    )}
                </Stack>

                <Card>
                    <CustomFilter
                        modalType="drawer"
                        filterModal={filterModal}
                        handleCloseModal={() => setFilterModal(false)}
                    >
                        <Stack spacing={2} sx={{ p: 2 }}>

                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Başlangıç Tarihi"
                                    value={startDate}
                                    onChange={setStartDate}
                                    format="DD/MM/YYYY"
                                />
                                <DatePicker
                                    label="Bitiş Tarihi"
                                    value={endDate}
                                    onChange={setEndDate}
                                    format="DD/MM/YYYY"
                                />
                            </LocalizationProvider>

                            <FormControl fullWidth>
                                <InputLabel>Kargo Durumu</InputLabel>
                                <Select
                                    value={selectedCargoStatus}
                                    label="Kargo Durumu"
                                    onChange={(e) => setSelectedCargoStatus(e.target.value)}
                                >
                                    <MenuItem value="">
                                        <em>Hepsi</em>
                                    </MenuItem>
                                    {[{ id: 1, label: "Yolda" }, { id: 2, label: "Teslim Edildi" }, { id: 3, label: "Muhaberata Ulaştı" }].map((b) => (
                                        <MenuItem key={b.id} value={b.id}>
                                            {b.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                                <TextField
                                    label="Gönderi Barkodu"
                                    variant="outlined"
                                    value={filterBarcode}
                                    onChange={(e) => setFilterBarcode(e.target.value)}
                                    sx={{ flexBasis: '20%', flexGrow: 1 }}
                                />
                            </FormControl>

                            <Divider />

                            <Stack direction="row" spacing={1} justifyContent="center">
                                <ClearButton onClick={() => console.log("Clear")} />
                                <FilterButton onClick={() => console.log("Filter")} />
                            </Stack>
                        </Stack>
                    </CustomFilter>

                    <DynamicTable
                        data={[]}
                        headers={TABLE_HEAD}
                        isMobile={isMobile}
                        isOrdered={true}
                        handleModal={() => setFilterModal(true)}
                        handleCloseModal={() => setFilterModal(false)}
                    />
                </Card>
            </Stack>
        </>
    )
}
